import React from "react";
import {
  ContentLayout,
  CustomDetailsList,
  HeaderBreadcrumbs,
  Loader,
  LoadingButton,
  usePermission,
} from "../../../shared";
import { Box, Chip, Divider, Paper, Stack, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import ResendIcon from "../../../assets/images/Icons/ic_resend.svg";
import { useEmailLogDetails } from "../hooks";

export const EmailLogDetails = () => {
  const { emailLogId } = useParams();
  const { state, breadcrumbs, handleResendEmail } = useEmailLogDetails();
  const hasResendPermission = usePermission("email-log-create");

  const status =
    state.emailDetails?.status === "Delivered"
      ? {
          color: "#0F875B",
          backgroundColor: "#E1FBF2",
          label: state.emailDetails?.status,
        }
      : {
          color: "#C42B1C",
          backgroundColor: "#FFE7E3",
          label: state.emailDetails?.status,
        };

  const detailsColumn = React.useMemo(
    () => [
      {
        title: "From",
        accessor: ({ from }) => {
          return (
            <Stack gap="4px" flexDirection="row" flexWrap="wrap">
              {from?.length <= 0
                ? "--"
                : from.map((item) => {
                    return (
                      <Typography variant="caption" color="GrayText">
                        {item.email}
                      </Typography>
                    );
                  })}
            </Stack>
          );
        },
      },
      {
        title: "To",
        accessor: ({ to_recipient }) => {
          return (
            <Stack gap="4px" flexDirection="row" flexWrap="wrap">
              {to_recipient.length <= 0
                ? "--"
                : to_recipient.map((item) => {
                    return <Chip label={item.email} />;
                  })}
            </Stack>
          );
        },
      },
      {
        title: "Date & Time",
        accessor: ({ sent_at }) => {
          return (
            <Typography variant="caption" color="GrayText">
              {sent_at}
            </Typography>
          );
        },
      },
      {
        title: "Type",
        accessor: ({ mail_class }) => {
          return (
            <Typography variant="caption" color="GrayText">
              {mail_class ?? "--"}
            </Typography>
          );
        },
      },
    ],
    []
  );

  return (
    <ContentLayout
      title={state.emailDetails?.subject ?? ""} // this should be dynamic based on the email log name
      chipType="other"
      statusContent={
        state.emailDetails?.status && (
          <Chip
            size="small"
            label={status.label}
            sx={{
              color: status.color,
              backgroundColor: status.backgroundColor,
            }}
          />
        )
      }
      breadcrumbs={<HeaderBreadcrumbs links={breadcrumbs} />}
      rightContent={
        hasResendPermission && (
          <LoadingButton
            startIcon={
              <Box
                component="img"
                src={ResendIcon}
                width="24px"
                height="24px"
                sx={{ opacity: state.resendButtonLoading ? "0.1" : 1 }}
              />
            }
            onClick={() => handleResendEmail(emailLogId)}
            loading={state.resendButtonLoading}
          >
            Resend
          </LoadingButton>
        )
      }
    >
      {state.isLoading ? (
        <Stack
          sx={{
            height: "calc(100vh - 200px)",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Loader />
        </Stack>
      ) : (
        <React.Fragment>
          <CustomDetailsList
            columns={detailsColumn}
            data={state.emailDetails}
            title="Details"
          />
          <Paper>
            <Typography sx={{ padding: "24px", fontSize: 16, fontWeight: 600 }}>
              Content
            </Typography>
            <Divider />
            <Stack
              padding={6}
              sx={{
                padding: "24px",
                gap: "16px",
              }}
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: state.emailDetails.html_body,
                }}
              />
            </Stack>
          </Paper>
        </React.Fragment>
      )}
    </ContentLayout>
  );
};
